export function checkEmail(strEmail) {
	const strRegExp = /^([a-zA-Z0-9_.-]){2,}@([a-zA-Z0-9-]+\.)+([a-zA-Z0-9]){2,}$/;
	return strRegExp.test(strEmail);
  }
  
  export function checkPassword(strPassword) {
	const strRegExp = /[A-Za-z0-9]*[0-9]+[a-z0-9]*[A-Z]+[a-z0-9A-Z]*|[A-Za-z0-9]*[A-Z]+[a-z0-9]*[0-9]+[a-z0-9A-Z]*/;
	return strRegExp.test(strPassword);
  }
  
  export function trim(strText) {
	while (strText.startsWith(' ')) {
	  strText = strText.substring(1);
	}
	while (strText.endsWith(' ')) {
	  strText = strText.substring(0, strText.length - 1);
	}
	return strText;
  }
  
  
  export function ValidarCuit(cuit) {
	cuit = trim(cuit);
  
	if (cuit.length !== 11) {
	  return false;
	}
  
	let acumulado = 0;
	const digitos = cuit.split("");
	const digito = digitos.pop();
  
	for (let i = 0; i < digitos.length; i++) {
	  acumulado += digitos[9 - i] * (2 + (i % 6));
	}
  
	let verif = 11 - (acumulado % 11);
	if (verif === 11) {
	  verif = 0;
	} else if (verif === 10) {
	  verif = 9;
	}
  
	return digito === verif.toString();
  }
  
  
  export function validarEmail(email) {
	const objRegExp1 = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
	return email.length > 0 ? objRegExp1.test(email) : false;
  }
  
  export function validarNroFactura(factura) {
	const objRegExp = /^[\d\s\-/]+$/;
	return factura.length > 0 ? objRegExp.test(factura) : false;
  }
  